import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Section1 from '../components/Section1';
import Section2 from '../components/Section2';
import Section3 from '../components/Section3';
import Section4 from '../components/Section4';
import Section5 from '../components/Section5';
import WebsiteLayout from '../layouts/WebsiteLayout';

const Home = () => {
  const { t, i18n } = useTranslation();
  const isFrench = i18n.language === 'fr';

  const metaTitle = isFrench
    ? 'Transport Dédié Carbone Neutre | Montréal – Québec | TransportSansGaz'
    : 'Carbon-Neutral Dedicated Transport | Montreal – Quebec | TransportSansGaz';

  const metaDescription = isFrench
    ? 'TransportSansGaz propose un transport dédié écoresponsable et carbone neutre entre Montréal et Québec. Optez pour une solution durable pour vos véhicules, palettes et équipements.'
    : 'TransportSansGaz offers eco-friendly, carbon-neutral dedicated transport between Montreal and Quebec. Choose sustainable transport for your vehicles, pallets, and machinery.';

  return (
    <WebsiteLayout>
      <Helmet>
        <html lang={isFrench ? 'fr' : 'en'} />
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
      <div id="header">
        <Header />
      </div>
      <div id="section1">
        <Section1 />
      </div>
      <div id="section2">
        <Section2 />
      </div>
      <div id="section3">
        <Section3 />
      </div>
      <div id="section4">
        <Section4 />
      </div>
      <div id="section5">
        <Section5 />
      </div>
    </WebsiteLayout>
  );
};

export default Home;
